document.addEventListener('DOMContentLoaded', function () {
  var tabs = document.querySelectorAll('#pg-tabs .pg-tab');
  var panels = document.querySelectorAll('.pg-panel');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var region = tab.getAttribute('data-region');
      tabs.forEach(function (t) { t.classList.remove('active'); });
      panels.forEach(function (p) { p.classList.remove('active'); });
      tab.classList.add('active');
      document.querySelector('.pg-panel[data-panel="' + region + '"]').classList.add('active');
    });
  });
});